import { Status } from '../enums/status.enum';
import { BaseModel } from './base.model';

export class User extends BaseModel {
    entityId?: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    username?: string;
    roles?: string[];
    status: boolean;
}

export class Credential extends BaseModel {
    userId?: number;
    id?: number;
    name?: string;
    email?: string;
    username?: string;
    phoneNumber?: string;
    roles?: Role[];
    firstname?: string;
    lastname?: string;
    constructor() {
        super();
        this.firstname = '';
        this.lastname = '';
    }
}

export interface ForgotPassword {
    result: boolean;
    resetCode: string;
}

export interface ResetPassword {
    username?: string;
    newPassword?: string;
    code?: string;
    email?: string;
    password?: string;
    token?: string;
}

export interface ChangePassword {
    username?: string;
    oldPassword: string;
    newPassword: string;
}

export interface Role {
    roleId: number;
    roleName: string;
    rules?: Rule[];
    resourceIds?: string[];
}

export interface Rule {
    resourceId: string;
}

export interface UpdateProfile {
    email: string;
    firstname: string;
    lastname: string;
    username: string;
}

export interface UserStatus {
    userId: number;
    status: number;
}

export interface SetPassword {
    userId: number;
    password: string;
}

export interface EditUser {
    id: string;
    password: string;
    email: string;
    firstname: string;
    lastname: string;
    roleId : string;
}

export interface ICreateUser {
    firstname: string;
    lastname: string;
    username: string;
    email: string;
    password: string;
    interfaceLocale: string;
    isActive: Status;
    roleId: string;
}
